
import { gql } from "@apollo/client";


export const UPDATE_ORDER_STATUS = gql`
  mutation UpdateOrder($id: ID!, $status: String!) {
    updateOrder(id: $id, status: $status) {  
      id
      status
    }
  }
`;


export const INITIATE_PHONEPE = gql`
  mutation InitiatePhonePe(
    $userId: ID!
    $amount: Float!
    $transactionId: String!
    $orderType: String
    $paymentGateway: String
    $items: [OrderItemInput!]!
    $addressId: ID!
  ) {
    initiatePhonePe(
      userId: $userId
      amount: $amount
      transactionId: $transactionId
      orderType: $orderType
      paymentGateway: $paymentGateway
      items: $items
      addressId: $addressId
    ) {
      orderId
      merchantTransactionId  
      state
      redirectUrl
    }
  }
`;


// Mutation for creating delivery
// Mutation for creating delivery
export const CREATE_DELIVERY_MUTATION = gql`
  mutation CreateDelivery(
    $orderId: String!,
    $trackId: String,          # ✅ optional input
    $driverId: ID,
    $vehicleId: ID,
    $status: String!,
    $location: JSON
  ) {
    createDelivery(
      orderId: $orderId,
      trackId: $trackId,        # ✅ pass trackId if provided
      driverId: $driverId,
      vehicleId: $vehicleId,
      status: $status,
      location: $location
    ) {
      id
      orderId
      trackId                   # ✅ return trackId
      driverId
      vehicleId
      status
      location
      createdAt
    }
  }
`;


// Mutation for updating delivery
// Mutation for updating delivery
export const UPDATE_DELIVERY_MUTATION = gql`
  mutation UpdateDelivery(
    $id: ID!,
    $status: String!,
    $location: JSON,
    $trackId: String            # ✅ optional, if you want to allow updating
  ) {
    updateDelivery(
      id: $id,
      status: $status,
      location: $location,
      trackId: $trackId          # ✅ pass trackId if provided
    ) {
      id
      orderId
      trackId                   # ✅ return trackId
      driverId
      vehicleId
      status
      location
      createdAt
    }
  }
`;


export const GET_DELIVERIES_QUERY = gql`
  query GetDeliveries($orderId: String!) {
    getDeliveries(orderId: $orderId) {
      id
      orderId
      trackId                   # ✅ return trackId
      driverId
      vehicleId
      status
      location
      createdAt
    }
  }
`;
